/* eslint-disable no-empty */
import { ResponseBasketballGetGameInfo } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const basketballGamesApi = createApi({
  reducerPath: 'basketballGamesApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchGameInfo: builder.query<ResponseBasketballGetGameInfo, number>({
      query: (request) => `basketball/games/${request}/info`,
    }),
  }),
});

// Export hooks for usage in functional components
export const { reducerPath, reducer, middleware, useFetchGameInfoQuery } =
  basketballGamesApi;
